<pr-expansion-panel
  [expandable]="entity.expandable ? entity.expandable : expandable"
  [expanded]="expanded"
  [redirect]="redirect"
  [tooltip]="tooltip"
>
  <!-- Panel Header -->
  <ng-container header>
    <ng-container
      [ngTemplateOutlet]="iconTemplate"
      [ngTemplateOutletContext]="{ $implicit: entity }"
    ></ng-container>
    <div class="full-w grid" [ngClass]="'grid-col-' + headersElements.length">
      @for (column of headersElements; track column) {
        <ng-template
          [ngTemplateOutlet]="columnDefinition"
          [ngTemplateOutletContext]="{ $implicit: column }"
        >
        </ng-template>
      }
    </div>
  </ng-container>
  <!-- Panel Body -->
  <div class="d-flex full-w align-items-center gap-xl flex-wrap" body>
    @for (column of bodyElements; track column) {
      <div>
        <ng-template
          [ngTemplateOutlet]="columnDefinition"
          [ngTemplateOutletContext]="{ $implicit: column }"
        >
        </ng-template>
      </div>
    }
    <ng-container
      [ngTemplateOutlet]="bodyTemplate"
      [ngTemplateOutletContext]="{ $implicit: entity }"
    ></ng-container>
  </div>
</pr-expansion-panel>

<ng-template #columnDefinition let-column>
  <div class="d-flex flex-column justify-content-center">
    <!-- Label -->
    @if (column.headerTemplate) {
      <p class="fs-12 fw-500 man">
        <ng-template
          [ngTemplateOutlet]="column.headerTemplate"
          [ngTemplateOutletContext]="{ $implicit: entity }"
        >
        </ng-template>
      </p>
    } @else {
      <p class="fs-12 fw-500 man">{{ column.label }}</p>
    }
    <!-- Value -->
    @if (column.valueTemplate) {
      <span
        class="fs-16 fit-content"
        [ngClass]="column.bold ? 'fw-600' : 'fw-400'"
      >
        <ng-template
          [ngTemplateOutlet]="column.valueTemplate"
          [ngTemplateOutletContext]="{ $implicit: entity }"
        >
        </ng-template>
      </span>
    } @else {
      <span
        class="fs-16 fit-content"
        [ngClass]="column.bold ? 'fw-600' : 'fw-400'"
        >{{
          entity[column.name].charAt(0).toUpperCase() +
            entity[column.name].slice(1).replace('_', ' ').toLowerCase()
        }}
      </span>
    }
  </div>
  @if (!column.headerTemplate && !column.valueTemplate) {}
</ng-template>
